import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StatisticsExternal } from '../entities/statisticsexternal.model';
import { StatisticsExternalFiltro } from '../entities/statisticsexternalfiltro.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class StatisticsExternalService {

    readonly BASE: any = PETICIONES.statisticsexternal;

    constructor(private http: HttpClient) { }


    /**
    * @description
    * Obtiene todas las statistics_external
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }


    /**
    * @description
    * Obtiene una statistic_external por su id
    */
    public findById(id: number): Observable<any> {
        let idstatistics: string = (id !== undefined && id !== null ? id + "" : "");
        return this.http.get(this.BASE.findById + "/" + idstatistics).pipe(delay(DELAY));
    }

    /**
    * @description
    * Mandamos un una statisticfiltro para busqueda filtro
    */
    public postStatisticsExternalFiltro(filtro: StatisticsExternalFiltro): Observable<any> {
        const json = JSON.stringify(filtro);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatisticsExternalFiltro, json, {headers: headers}).pipe(delay(DELAY));
    }



    /**
    * @description
    * Guarda una statistic en la base de datos
    */
    public postStatisticsExternalSesion(statistics: StatisticsExternal, hora: number): Observable<any> {
        const json = JSON.stringify(statistics);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatisticsExternalSesion + "/" + hora , json, {headers: headers}).pipe(delay(DELAY));
    }


    /**
    * @description
    * Guarda una statistic_external en la base de datos
    */
    public postStatisticsExternal(statistics: StatisticsExternal): Observable<any> {
        const json = JSON.stringify(statistics);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postStatisticsExternal, json, {headers: headers}).pipe(delay(DELAY));
    }


    /**
    * @description
    * Borra una statistics en la base de datos
    */
    public deleteStatisticsExternal(statistics: StatisticsExternal): Observable<any> {
        let idstatistics: string = (statistics.id !== undefined && statistics.id !== null ? statistics.id + "" : "");
        return this.http.get(this.BASE.deleteStatisticsExternal + "/" + idstatistics).pipe(delay(DELAY));
    }
}